
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'FacebookFull'
})
export default class FacebookFull extends Vue {}
